import { useState } from "react";
import { getDomainIntegration } from "./service";

function useDomainIntegration(workspaceId, assistantId) {
  const [domainIntegration, setDomainIntegration] = useState({
    data: {
      domainIdentifiers: [],
    },
    isLoading: true,
    isCreated: false,
  });

  const fetchDomainIntegration = async () => {
    try {
      const response = await getDomainIntegration({ workspaceId, assistantId });
      if (response.status === 200) {
        setDomainIntegration({
          data: response.data,
          isLoading: false,
          isCreated: true,
        });
      }
    } catch (e) {
      setDomainIntegration((prevState) => {
        return {
          ...prevState,
          //   data: {
          //     domainIdentifiers: ["http://localhost:3000"],
          //   },
          isLoading: false,
          isCreated: false,
        };
      });
      console.error("Failed to get domain integration");
    }
  };

  return {
    ...domainIntegration,
    setDomainIntegration,
    fetchDomainIntegration,
  };
}

export default useDomainIntegration;
